export const MIN_AGE = 16;
export const MIN_YEAR = 1900;
export const WAITING_TIME_IN_DAYS = 10;
export const MONTH_YEAR_LENGTH = 6;
export const TIMEZONE = 'America/New_York';
export const LOCALE = 'us';
export const MIN_YEARS_AMOUNT = 2;
export const MAX_INCOME_VALUE = 9999999;
export const BORROWER_LAST_NAME_MIN_LENGTH = 2;
export const BORROWER_FIRST_LAST_NAME_MAX_LENGTH = 100;
export const ZIP_CODE_MAX_LENGTH = 5;
export const SSN_MAX_LENGTH = 9;
export const LAST_4_DIGITS_SSN_LENGTH = 4;
export const ROUTING_NUMBER_LENGTH = 9;
export const INCOME_AMOUNT_MAX_LENGTH = 9;
export const CHECKING_ACCOUNT_NUMBER_MIN_LENGTH = 4;
export const CHECKING_ACCOUNT_NUMBER_MAX_LENGTH = 17;
export const MASKED_SSN_LENGTH = 11;
export const MAX_LOAN_AMOUNT_LENGTH = 8;
export const MAX_EMPLOYMENT_NAME_LENGTH = 40;
export const EMPLOYMENT_ERROR_MESSAGE = 'Employer Company Name Should Be No More Than 40 Characters';
export const POSITION_ERROR_MESSAGE = 'Position Should Be No More Than 40 Characters';
export const TRUV_DISABLED_STATUS = 'disabled';
export const DEFAULT_DEBOUNCE_TIMEOUT = 500;
export const EMPTY_VALUE_SYMBOL = '-';
export const PARSE_MONTH_YEAR_DAY_OFFSET = 1;
